import { render } from "./HomeCoord.vue?vue&type=template&id=d85ced3a"
import script from "./HomeCoord.vue?vue&type=script&lang=js"
export * from "./HomeCoord.vue?vue&type=script&lang=js"

import "./HomeCoord.vue?vue&type=style&index=0&id=d85ced3a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__